import axios from "axios";
import { getCorrelationId } from "../utils/correlation-id";
import { getEnvVar } from "../utils/get-env";

const baseURL = process.env.NODE_ENV === "local" ? "http://localhost:3939" : getEnvVar("REACT_APP_AMAZON_CONNECT_URL");

export const gatewayAmazonConnect = axios.create({
  baseURL,
  timeout: 90000,
  headers: {
    "x-correlation-id": getCorrelationId(),
  },
});
